import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

function openNavMobileMenu() {
  disableBodyScroll(document.querySelector('.nav-mobile-wrapper'));
}

function closeNavMobileMenu() {
  enableBodyScroll(document.querySelector('.nav-mobile-wrapper'));
}


// Add spans
$('#nav-mobile-menu > li.menu-item-has-children').each(function(){
  $(this).append('<span class="arrow"></span>');
});

$('#nav-mobile-menu .arrow').on('click', function() {
  if($(this).prev().hasClass('show')) {
    $(this).prev().removeClass('show');
  } else {
    $(this).prev().addClass('show');
  }
});


$('.nav-mobile-trigger').on('click', function(){
  if($(this).hasClass('show')) {
    $(this).removeClass('show');
    $('.nav-mobile-menu-wrapper').removeClass('show');
    closeNavMobileMenu();
  } else {
    $(this).addClass('show');
    $('.nav-mobile-menu-wrapper').addClass('show');
    openNavMobileMenu();
  }
});